import * as Yup from "yup";

export const validationSchemaCartComment = Yup.object().shape({
  comment: Yup.string()
    .required("Comment is required")
    .max(200, "Enter less than 200 characters"),
});

export const CarTManufacturingFormSchema = Yup.object().shape({
  leukapheresis_condition: Yup.number()
    .nullable()
    .typeError("Leukapheresis condition must be a number")
    .required("Leukapheresis condition is required"),
  cd3_t_cells_in_leukapheresis: Yup.number()
    .nullable()
    .typeError("CD3+ T cells in leukapheresis must be a number")
    .required("CD3+ T cells in leukapheresis is required"),
  cd3_t_cells_taken_for_md: Yup.number()
    .nullable()
    .typeError("CD3+ T cells taken for MD must be a number")
    .required("CD3+ T cells taken for MD is required"),
  cd3_t_cells_after_md: Yup.number()
    .nullable()
    .typeError("CD3+ T cells after MD must be a number")
    .required("CD3+ T cells after MD is required"),
  cd3_t_cells_for_selection: Yup.number()
    .nullable()
    .typeError("CD3+ T cells for selection must be a number")
    .required("CD3+ T cells for selection is required"),
  cd3_t_cells_after_selection: Yup.number()
    .nullable()
    .typeError("CD3+ T cells after selection must be a number")
    .required("CD3+ T cells after selection is required"),

  nos_of_bags: Yup.number()
    .nullable()
    .typeError("Number of bags must be a number")
    .required("Number of bags is required"),
  cd3_t_cells_in_each_bag: Yup.number()
    .nullable()
    .typeError("CD3+ T cells in each bag must be a number")
    .required("CD3+ T cells in each bag is required"),
  storage_location: Yup.number()
    .nullable()
    .typeError("Storage location must be a number")
    .required("Storage location is required"),
  cd3_t_cells_transduced: Yup.number()
    .nullable()
    .typeError("CD3+ T cells transduced must be a number")
    .required("CD3+ T cells transduced is required"),
  moi: Yup.number()
    .nullable()
    .typeError("MOI must be a number")
    .required("MOI is required"),
  te_at_day_05: Yup.number()
    .nullable()
    .typeError("TE at Day 05 must be a number")
    .required("TE at Day 05 is required"),
  te_at_harvest: Yup.number()
    .nullable()
    .typeError("TE at harvest must be a number")
    .required("TE at harvest is required"),
  total_t_cells_harvested: Yup.number()
    .nullable()
    .typeError("Total T cells harvested must be a number")
    .required("Total T cells harvested is required"),
  total_t_cells_given_to_qc: Yup.number()
    .nullable()
    .typeError("Total T cells given to QC must be a number")
    .required("Total T cells given to QC is required"),
  md_value: Yup.number()
    .nullable()
    .typeError("MD value must be a number")
    .required("MD value is required"),
  total_t_cells_harvested_2: Yup.number()
    .nullable()
    .typeError("Total T cells harvested (2) must be a number")
    .required("Total T cells harvested (2) is required"),
  total_t_cells_given_to_qc_2: Yup.number()
    .nullable()
    .typeError("Total T cells given to QC (2) must be a number")
    .required("Total T cells given to QC (2) is required"),
  total_car_t_cells_filled: Yup.number()
    .nullable()
    .typeError("Total CAR-T cells filled must be a number")
    .required("Total CAR-T cells filled is required"),
  car_t_dose_per_kg: Yup.number()
    .nullable()
    .typeError("CAR-T dose per kg must be a number")
    .required("CAR-T dose per kg is required"),

  cell_count: Yup.array()
    .of(
      Yup.object().shape({
        day: Yup.string()
          .trim()
          .required("Day is required"),
        total_cell_count: Yup.number()
          .nullable()
          .typeError("Total cell count must be a number")
          .required("Total cell count is required"),
      })
    )
    .min(1, "At least one cell count entry is required")
    .required("Cell count is required"),

  remarks: Yup.string()
    .max(200, "Remarks cannot exceed 200 characters")
    .required("Remarks are required"),
  //   remarks_lead: Yup.string()
  //     .max(200, "Remarks lead cannot exceed 200 characters")
  //     .required("Remarks lead is required"),
});

export const cartInitialValues = {
  leukapheresis_condition: '',
  cd3_t_cells_in_leukapheresis: '',
  cd3_t_cells_taken_for_md: '',
  cd3_t_cells_after_md: '',
  cd3_t_cells_for_selection: '',
  cd3_t_cells_after_selection: '',

  nos_of_bags: '',
  cd3_t_cells_in_each_bag: '',
  storage_location: '',
  cd3_t_cells_transduced: '',
  moi: '',
  te_at_day_05: '',
  te_at_harvest: '',
  total_t_cells_harvested: '',
  total_t_cells_given_to_qc: '',
  md_value: '',
  total_t_cells_harvested_2: '',
  total_t_cells_given_to_qc_2: '',
  total_car_t_cells_filled: '',
  car_t_dose_per_kg: '',

  cell_count: [{ day: "", total_cell_count: "" }],
  remarks: "",
  remarks_lead: "",
}
